// ======================================================================
// File Name       : ContentLinkCourseSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form, Button } from 'react-bootstrap';
import { CONTENT_TYPE } from '../../../constants/CSVDownloadConstant';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import { CONTENT_TYPE_STR } from '../../../constants/ContentHistoryConstant';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';

class ContentLinkCourseSearch extends Component {

  render() {
    const { userAttributeKeyNum, userAttributeSearchText } = this.props;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.props.handleSearch();
        }}
        className='form-horizontal'
      >
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              コンテンツ名(コース表示名称)
            </Col>
            <Col sm={8} className="padding-right-15">
              <RenderField type="text" name="contentName" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              コンテンツ種別
            </Col>
            <Col sm={8} className="padding-right-15">
              <RenderField
                data={CONTENT_TYPE_STR}
                name="contentType"
                type="selectbox"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              コース名
            </Col>
            <Col sm={8} className="padding-right-15">
              <RenderField type="text" name="courseName" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              セクション名
            </Col>
            <Col sm={8} className="padding-right-15">
              <RenderField type="text" name="boxName" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              自サービス/外部
            </Col>
            <Col sm={8} className="padding-top-10">
              <Col sm={3} className="padding-left-clear">
                <RenderField
                  type="radio"
                  name="contentTypeRadio"
                  value={CONTENT_TYPE.NO_SELECTION}
                  label="選択なし"
                />
              </Col>
              <Col sm={5} className="padding-clear">
                <RenderField
                  type="radio"
                  name="contentTypeRadio"
                  value={CONTENT_TYPE.SERVICE_CONTENT}
                  label="自サービスコンテンツ"
                />
              </Col>
              <Col sm={4}>
                <RenderField
                  type="radio"
                  name="contentTypeRadio"
                  value={CONTENT_TYPE.EXTERNAL_CONTENT}
                  label="外部コンテンツ"
                />
              </Col>
            </Col>
          </Form.Group>

          <Form.Group className="text-center">
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              {/* <Button bsStyle="primary" className="btn-96" type="submit">
                search
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>

        </Col>
      </Form>
    );
  }
}

export default ContentLinkCourseSearch;
